import './styles.css';

export default ({
  isLoadingPage,
  isLoadingAnimation,
  isLoadingAnimationDisplay,
}) => {
  return (
    <div
      className={`container ${
        isLoadingAnimationDisplay === false ? 'display-none' : null
      } ${isLoadingAnimation === false ? 'opacity-none' : null}`}
    >
      <div className="row beans"></div>
    </div>
  );
};
